import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { Sc4MessageCheckerFacade } from './sc4-message-checker.facade';

@Injectable({
  providedIn: 'root',
})
export class Sc4MessageCheckerGuard  {
  constructor(private sc4MessageCheckerFacade: Sc4MessageCheckerFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.sc4MessageCheckerFacade);
  }
}
